module.exports = __webpack_public_path__ + "img/b.6f06f388.jpg";